import axios from "axios";

function getAllLinhVuc(){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/public/getalllinhvuc");
};


const PublicService={
  getAllLinhVuc
};
export default PublicService;
